// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1FH0QbcrtO04TSWZhVY6u-{padding-bottom:5.6rem;padding-top:2.4rem}._1h-9h9WJqrwwUdBahAu8xz{margin-top:2.4rem}._23ETgGJIbww02Kh07zq8fs{-webkit-box-orient:vertical;-webkit-line-clamp:3;display:-webkit-box;overflow:hidden}@media (min-width:992px){._1FH0QbcrtO04TSWZhVY6u-{padding-top:3.2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_1FH0QbcrtO04TSWZhVY6u-",
	"list": "_1h-9h9WJqrwwUdBahAu8xz",
	"clampText": "_23ETgGJIbww02Kh07zq8fs"
};
module.exports = ___CSS_LOADER_EXPORT___;
